import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import Area from 'models/Area';
import Category from 'models/Category';

function SinglePoiCrumbs({ region, municipality, category }: { region: Area; municipality: Area; category: Category }) {
    if (!region || !municipality || !category) return null;

    const crumbs = [
        {
            label: region.name,
            link: `/ideje/${region.slug}`
        },
        {
            label: municipality.name,
            link: `/ideje/${municipality.slug}`
        },
        {
            label: category.name,
            link: `/ideje/${municipality.slug}/${category.slug}`
        }
    ];

    return <Breadcrumbs crumbs={crumbs} />;
}

export default SinglePoiCrumbs;
